<form class="customer-loss-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INVOICE.CUSTOMER_LOSS_HEADER' | translate }} {{ dataContext.invoiceNumber }}</h4>
  @if (hasOngoingAmortizationPlan) {
    <app-information-block status="warning" [text]="'INVOICE.ONGOING_AMORTIZATION_PLAN_INFO' | translate"></app-information-block>
  }
  <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <app-text-box-readonly
        [caption]="'INVOICE.INVOICEAMOUNT'"
        [text]="dataContext.amount.amount | money: false : null : dataContext.amount.currencyCode"
      ></app-text-box-readonly>
      <app-text-box-readonly
        [caption]="'INVOICE.REMAINING_AMOUNT'"
        [text]="dataContext.remainingAmount.amount | money: false : null : dataContext.remainingAmount.currencyCode"
      ></app-text-box-readonly>
    </astral-layout-group>
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <app-money-box [control]="form.controls['amount']"></app-money-box>
      <astral-date-picker [control]="form.controls['verificationBusinessTransactionDate']"></astral-date-picker>
    </astral-layout-group>
    @if (errorMessage) {
      <span class="error">{{ errorMessage | translate }}</span>
    }
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" [disabled]="form.disabled" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" [disabled]="form.disabled" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
